import script from "./headerHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./headerHtml.vue?vue&type=script&setup=true&lang=js"

import "./headerHtml.vue?vue&type=style&index=0&id=be23091a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be23091a"]])

export default __exports__